(() => {
  const root = document.querySelector('[data-monolith-advisors]');
  if (!root) return;
  let product;
  try { product = JSON.parse(root.querySelector('[data-advisor-purchase-data]').textContent); } catch { product = {title:'',variants:[]}; }
  const translations = {
  "de": [
    "Warum kann ich nicht kaufen?",
    "Benachrichtigung klappt nicht",
    "Wähle zuerst die gewünschte Variante auf der Produktseite.",
    "Auf der Produktseite ist ein sichtbarer Coming-soon-Button aktiv. Das ist noch kein regulärer Verkaufsstart und keine Vorbestellung. Ein Termin wird hier nicht zugesagt.",
    "Die gewählte Variante ist auf dieser Seite als nicht verfügbar hinterlegt. Andere Varianten können einen anderen Status haben.",
    "Die gewählte Variante ist auf dieser Seite als verfügbar hinterlegt. Falls der Kauf trotzdem nicht klappt, prüfen wir gerne das konkrete Problem.",
    "Prüfe die gewählte Farbe oder Variante auf der Produktseite.",
    "Prüfe Menge, Pflichtoptionen und sichtbare Hinweise beim Kaufbutton.",
    "Übernimm die Angaben mit „Ich brauche Hilfe“ in eine Anfrage.",
    "Status erneut prüfen",
    "Ich brauche Hilfe",
    "Prüfe deine eingegebene E-Mail-Adresse und den Spamordner. Eine Anmeldung ist noch keine Zusage für einen Restock oder eine Reservierung.",
    "Was funktioniert nicht?",
    "Der Benachrichtigungsbutton fehlt",
    "Die Anmeldung lässt sich nicht absenden",
    "Nach der Anmeldung kam keine Bestätigung",
    "Keine Nachricht trotz erneuter Verfügbarkeit",
    "Technische Anfrage vorbereiten",
    "Variante noch nicht gewählt"
  ],
  "en": [
    "Why can’t I buy this?",
    "Stock notification is not working",
    "First select the variant you want on the product page.",
    "A Coming soon button is visible on the product page. This is not a regular sales launch or a preorder. No launch date is promised here.",
    "The selected variant is marked unavailable on this page. Other variants may have a different status.",
    "The selected variant is marked available on this page. If buying still fails, we can investigate the specific problem.",
    "Check the colour or variant selected on the product page.",
    "Check quantity, required options and visible notices by the buy button.",
    "Use “I need help” to include these details in an enquiry.",
    "Check status again",
    "I need help",
    "Check the email address entered and your spam folder. Signing up does not promise a restock or reserve an item.",
    "What is not working?",
    "The notification button is missing",
    "The sign-up form will not submit",
    "No confirmation after signing up",
    "No email despite the item being available again",
    "Prepare a technical enquiry",
    "No variant selected yet"
  ],
  "fr": [
    "Pourquoi ne puis-je pas acheter ?",
    "L’alerte de stock ne fonctionne pas",
    "Choisissez d’abord la variante souhaitée sur la page produit.",
    "Un bouton Coming soon est visible sur la page. Il ne s’agit ni d’un lancement de vente ni d’une précommande. Aucune date n’est promise ici.",
    "La variante choisie est indiquée indisponible sur cette page. Les autres variantes peuvent avoir un statut différent.",
    "La variante choisie est indiquée disponible sur cette page. Si l’achat échoue, nous pouvons examiner le problème.",
    "Vérifiez la couleur ou variante choisie sur la page produit.",
    "Vérifiez la quantité, les options requises et les indications près du bouton d’achat.",
    "Utilisez « J’ai besoin d’aide » pour reprendre ces détails dans une demande.",
    "Vérifier à nouveau",
    "J’ai besoin d’aide",
    "Vérifiez l’adresse e-mail saisie et les spams. L’inscription ne garantit ni réassort ni réservation.",
    "Qu’est-ce qui ne fonctionne pas ?",
    "Le bouton d’alerte est absent",
    "Le formulaire d’inscription ne s’envoie pas",
    "Aucune confirmation après l’inscription",
    "Aucun e-mail malgré le retour en stock",
    "Préparer une demande technique",
    "Aucune variante choisie"
  ],
  "it": [
    "Perché non posso acquistare?",
    "L’avviso di disponibilità non funziona",
    "Seleziona prima la variante desiderata nella pagina prodotto.",
    "Nella pagina è visibile un pulsante Coming soon. Non è ancora una vendita regolare né un preordine. Qui non viene promessa una data.",
    "La variante scelta risulta non disponibile in questa pagina. Altre varianti possono avere uno stato diverso.",
    "La variante scelta risulta disponibile in questa pagina. Se l’acquisto non riesce, possiamo verificare il problema.",
    "Controlla il colore o la variante scelti nella pagina prodotto.",
    "Controlla quantità, opzioni obbligatorie e avvisi vicino al pulsante di acquisto.",
    "Usa « Ho bisogno di aiuto » per includere questi dati nella richiesta.",
    "Ricontrolla lo stato",
    "Ho bisogno di aiuto",
    "Controlla l’email inserita e lo spam. L’iscrizione non garantisce un riassortimento né una prenotazione.",
    "Cosa non funziona?",
    "Manca il pulsante di avviso",
    "Non riesco a inviare l’iscrizione",
    "Nessuna conferma dopo l’iscrizione",
    "Nessuna email nonostante la nuova disponibilità",
    "Prepara una richiesta tecnica",
    "Nessuna variante selezionata"
  ],
  "es": [
    "¿Por qué no puedo comprar?",
    "El aviso de stock no funciona",
    "Primero elige la variante deseada en la página del producto.",
    "Hay un botón Coming soon visible en la página. Aún no es una venta normal ni una preventa. Aquí no se promete una fecha.",
    "La variante elegida figura como no disponible en esta página. Otras variantes pueden tener otro estado.",
    "La variante elegida figura como disponible en esta página. Si no puedes comprar, revisaremos el problema concreto.",
    "Comprueba el color o variante elegidos en la página del producto.",
    "Revisa cantidad, opciones obligatorias y avisos junto al botón de compra.",
    "Usa « Necesito ayuda » para incluir estos datos en una consulta.",
    "Volver a comprobar",
    "Necesito ayuda",
    "Revisa el correo introducido y el spam. Registrarse no garantiza reposición ni reserva un artículo.",
    "¿Qué no funciona?",
    "Falta el botón de aviso",
    "No puedo enviar el formulario de registro",
    "Sin confirmación tras registrarme",
    "Sin correo pese a volver a estar disponible",
    "Preparar consulta técnica",
    "Ninguna variante elegida"
  ],
  "pl": [
    "Dlaczego nie mogę kupić?",
    "Powiadomienie nie działa",
    "Najpierw wybierz wariant na stronie produktu.",
    "Na stronie widać przycisk Coming soon. To jeszcze nie regularna sprzedaż ani przedsprzedaż. Nie obiecujemy tu daty premiery.",
    "Wybrany wariant jest na tej stronie niedostępny. Inne warianty mogą mieć inny status.",
    "Wybrany wariant jest na tej stronie dostępny. Jeśli zakup nie działa, możemy sprawdzić konkretny problem.",
    "Sprawdź kolor lub wariant wybrany na stronie produktu.",
    "Sprawdź ilość, wymagane opcje i informacje przy przycisku zakupu.",
    "Użyj „Potrzebuję pomocy”, aby dołączyć te dane do zgłoszenia.",
    "Sprawdź ponownie",
    "Potrzebuję pomocy",
    "Sprawdź wpisany e-mail i spam. Zapis nie gwarantuje uzupełnienia zapasów ani rezerwacji produktu.",
    "Co nie działa?",
    "Brak przycisku powiadomienia",
    "Nie można wysłać formularza zapisu",
    "Brak potwierdzenia po zapisie",
    "Brak e-maila mimo ponownej dostępności",
    "Przygotuj zgłoszenie techniczne",
    "Nie wybrano wariantu"
  ],
  "sv": [
    "Varför kan jag inte köpa?",
    "Lageraviseringen fungerar inte",
    "Välj först önskad variant på produktsidan.",
    "En Coming soon-knapp är synlig på sidan. Det är ännu inte vanlig försäljning eller förbeställning. Inget datum utlovas här.",
    "Den valda varianten anges som otillgänglig på sidan. Andra varianter kan ha annan status.",
    "Den valda varianten anges som tillgänglig på sidan. Om köpet ändå inte fungerar kan vi undersöka problemet.",
    "Kontrollera färg eller variant på produktsidan.",
    "Kontrollera antal, obligatoriska val och meddelanden vid köpknappen.",
    "Använd ”Jag behöver hjälp” för att ta med uppgifterna i en förfrågan.",
    "Kontrollera status igen",
    "Jag behöver hjälp",
    "Kontrollera angiven e-postadress och skräppost. Anmälan lovar inte påfyllning och reserverar ingen vara.",
    "Vad fungerar inte?",
    "Aviseringsknappen saknas",
    "Anmälan går inte att skicka",
    "Ingen bekräftelse efter anmälan",
    "Inget mejl trots att varan finns igen",
    "Förbered teknisk förfrågan",
    "Ingen variant vald"
  ],
  "fi": [
    "Miksi en voi ostaa?",
    "Saatavuusilmoitus ei toimi",
    "Valitse ensin haluamasi vaihtoehto tuotesivulla.",
    "Sivulla näkyy Coming soon -painike. Kyse ei ole vielä normaalista myynnistä eikä ennakkotilauksesta. Tässä ei luvata julkaisupäivää.",
    "Valittu vaihtoehto on tällä sivulla merkitty loppuunmyydyksi. Muilla vaihtoehdoilla voi olla eri tila.",
    "Valittu vaihtoehto on tällä sivulla merkitty saatavilla olevaksi. Jos osto ei onnistu, voimme selvittää ongelman.",
    "Tarkista tuotesivulla valittu väri tai vaihtoehto.",
    "Tarkista määrä, pakolliset valinnat ja ostopainikkeen lähellä olevat ohjeet.",
    "Siirrä tiedot yhteydenottoon valitsemalla ”Tarvitsen apua”.",
    "Tarkista tila uudelleen",
    "Tarvitsen apua",
    "Tarkista antamasi sähköposti ja roskaposti. Ilmoittautuminen ei lupaa lisävarastoa eikä varaa tuotetta.",
    "Mikä ei toimi?",
    "Ilmoituspainike puuttuu",
    "Ilmoittautumista ei voi lähettää",
    "Ei vahvistusta ilmoittautumisen jälkeen",
    "Ei viestiä vaikka tuote on taas saatavilla",
    "Valmistele tekninen yhteydenotto",
    "Vaihtoehtoa ei ole valittu"
  ],
  "nl": [
    "Waarom kan ik niet kopen?",
    "Voorraadmelding werkt niet",
    "Kies eerst de gewenste variant op de productpagina.",
    "Er staat een zichtbare Coming soon-knop op de pagina. Dit is nog geen gewone verkoop of pre-order. Hier wordt geen datum beloofd.",
    "De gekozen variant staat op deze pagina als niet beschikbaar. Andere varianten kunnen een andere status hebben.",
    "De gekozen variant staat op deze pagina als beschikbaar. Als kopen toch niet lukt, kunnen we het probleem onderzoeken.",
    "Controleer de gekozen kleur of variant op de productpagina.",
    "Controleer aantal, verplichte opties en meldingen bij de koopknop.",
    "Gebruik “Ik heb hulp nodig” om deze gegevens in een aanvraag op te nemen.",
    "Status opnieuw controleren",
    "Ik heb hulp nodig",
    "Controleer het ingevulde e-mailadres en je spammap. Aanmelden garandeert geen nieuwe voorraad en reserveert geen artikel.",
    "Wat werkt niet?",
    "De meldingsknop ontbreekt",
    "Het aanmelden kan niet worden verstuurd",
    "Geen bevestiging na aanmelding",
    "Geen mail ondanks nieuwe beschikbaarheid",
    "Technische aanvraag voorbereiden",
    "Nog geen variant gekozen"
  ]
};
  const locale = root.dataset.locale?.split('-')[0];
  const t = translations[locale] || translations.en;
  const query = key => root.querySelector(`[data-advisor-${key}]`);
  for (const [key, index] of Object.entries({'buy-title':0,'notify-title':1,'buy-check':9,'buy-question':10,'notify-hint':11,'notify-label':12,'notify-request':17})) query(key).textContent = t[index];
  for (const text of t.slice(6,9)) {
    const step = document.createElement('li'); step.textContent = text; query('buy-steps').append(step);
  }
  const problem = query('notify-problem');
  for (let index = 13; index <= 16; index++) {
    const option = document.createElement('option'); option.value = String(index); option.textContent = t[index]; problem.append(option);
  }
  const box = () => document.querySelector('.product__info-container, .product__info-wrapper, .product__blocks, .product-info');
  const variant = () => {
    const container = box();
    const input = container?.querySelector('.main-product-form input.product-variant-id, form[action*="/cart/add"] [name="id"]');
    const id = input ? input.value : product.selected;
    return (product.variants || []).find(item => String(item.id) === String(id));
  };
  const comingSoon = () => Array.from((box() || document).querySelectorAll('.timesact-button-cs')).some(button => button.getClientRects().length && getComputedStyle(button).display !== 'none' && getComputedStyle(button).visibility !== 'hidden');
  const reference = (withId = true) => {
    const selected = variant();
    return [product.title, selected ? (selected.title === 'Default Title' ? '' : selected.title) + (withId ? ' (#' + selected.id + ')' : '') : t[18]].filter(Boolean).join(' · ').slice(0,500);
  };
  const update = () => {
    const selected = variant();
    query('buy-product').textContent = reference(false);
    query('notify-product').textContent = reference(false);
    query('buy-status').textContent = comingSoon() ? t[3] : !selected ? t[2] : selected.available ? t[5] : t[4];
  };
  const request = (area, source, text) => {
    root.dispatchEvent(new CustomEvent('monolith:technical-request', {detail:{area,source,product:reference(),problem:text.slice(0,150)}}));
  };
  query('buy-check').addEventListener('click', update);
  query('buy-question').addEventListener('click', () => request('cart', query('buy-question'), t[0]));
  query('notify-request').addEventListener('click', () => request('restock', query('notify-request'), problem.selectedOptions[0].textContent));
  root.addEventListener('monolith:view', event => { if (['buyhelp','notifyhelp'].includes(event.detail.name)) update(); });
  document.addEventListener('variant:changed', update);
  document.addEventListener('change', event => { if (!root.contains(event.target) && box()?.contains(event.target)) update(); });
  update();
})();

